import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/nPLRoutes/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/nPLRoutes/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/nPLRoutes/GetById`, payload),
    Add: (payload) => Repository.post(`/api/nPLRoutes/Add`, payload),
    Check: (payload) => Repository.post(`/api/nPLRoutes/Check`, payload),
    Edit: (payload) => Repository.post(`/api/nPLRoutes/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/nPLRoutes/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/nPLRoutes/ChangeStatus`, payload),
}